module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1524-3b6aba430bd18ebd0d0879efe3664f77.png";